import { render, staticRenderFns } from "./ElementModal.vue?vue&type=template&id=2d81b368&scoped=true&"
import script from "./ElementModal.vue?vue&type=script&lang=js&"
export * from "./ElementModal.vue?vue&type=script&lang=js&"
import style0 from "./ElementModal.vue?vue&type=style&index=0&id=2d81b368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81b368",
  null
  
)

export default component.exports